import * as React from "react";
import { Link } from "react-router-dom";
import { reverse } from "named-urls";
import { routes } from "../../../Routes";
import { Button } from "@material-ui/core";
import { useNavbarStyles } from "../Navbar.styles";

interface ISimplePageProps {
  reference: string;
  closeMenuOnClick?: () => void;
  icon: any;
  title: string;
}

const SimplePage: React.FC<ISimplePageProps> = (props): JSX.Element => {
  const classes = useNavbarStyles({});
  const { closeMenuOnClick, ...rest } = props;

  return (
    <Button
      {...rest}
      className={classes.menuItem}
      onClick={props.closeMenuOnClick}
      component={Link}
      to={reverse(routes.cmsPage, {
        reference: props.reference,
      })}
    >
      {props.title}
      <img src={props.icon} alt="arrow" />
    </Button>
  );
};

export default SimplePage;
